export default {
  getGithubLink: (componentName) => {
    return `https://github.com/cebroker/emerald-ui/tree/master/apps/emerald-ui/src/${componentName}`;
  },
  getStorybookLink: (componentName) => {
    return `https://storybook-emerald.condorlabs.io?path=/story/${componentName.toLowerCase()}--default`;
  },
  getImportCode: (Components) => {
    return Components.map(({ componentName }) => {
      return `import ${componentName} from 'emerald-ui/lib/${componentName}';\n`;
    });
  },
  getEmeraldLink: (componentName) => {
    return `http://emeraldui.com/Components_${componentName}`;
  },
};
